<template>
  <div class="app-smart-table">
    <!--begin::Data Table-->
    <div class="app-smart-table__table_container" @scroll="onScroll">
      <table id="wtable">
        <!--begin::Table Head-->
        <thead>
          <tr>
            <template v-for="(item, index) in headers">
              <th
                :key="index"
                :class="[
                  { sortable: item.sortable },
                  { 'sticky-left': item.fixedLeft },
                  { 'sticky-right': item.fixedRight },
                  { setBorder: setBorderLeft == item.fixedLeft },
                  { setBorder: setBorderRight == item.fixedRight },
                ]"
                :style="item.headerStyle"
                @click="onClickSort(item)"
              >
                <div class="d-flex" :class="item.headersClass">
                  <span
                    class="text-nowrap"
                    :class="[{ 'active-sort': sortBy == item.key }]"
                  >
                    {{ $t(`label.${item.name}`) }}
                  </span>

                  <!-- begin:: Sort Icon Wrapper -->
                  <div v-if="item.sortable" class="sort-icon-wrapper">
                    <i v-if="sortBy != item.key" class="fas fa-sort"></i>
                    <i
                      v-if="
                        sortBy == item.key && currentSortDir == sortOrder.ASC
                      "
                      class="fas fa-sort-amount-up-alt text-primary"
                    ></i>
                    <i
                      v-if="
                        sortBy == item.key && currentSortDir == sortOrder.DESC
                      "
                      class="fas fa-sort-amount-down text-primary"
                    ></i>
                  </div>
                  <!-- end:: Sort Icon Wrapper -->
                </div>
              </th>
            </template>
          </tr>
        </thead>
        <!--end::Table Head-->

        <!--begin::Table Body-->
        <tbody>
          <template v-for="item in sortedItems">
            <tr :key="item.no">
              <template v-for="(head, headIndex) in headers">
                <td
                  :key="headIndex"
                  :class="[
                    { 'sticky-left': head.fixedLeft },
                    { 'sticky-right': head.fixedRight },
                    { setBorder: setBorderLeft == head.fixedLeft },
                    { setBorder: setBorderRight == head.fixedRight },
                  ]"
                >
                  <div :class="head.class" :style="head.style">
                    <component
                      v-if="head.layout"
                      :is="head.layout"
                      :item="item"
                      :value="item[head.key]"
                      :header="head"
                      :layoutActions="head.layoutActions"
                      :accessRights="accessRights"
                      :subMenu="subMenu"
                      :config="head.config"
                      :options="head.options"
                      :optionsValue="head.optionsValue"
                      @app-table-actions-read-details="actionReadDetails"
                      @app-table-actions-open-modal-details="
                        actionOpenModalDetails
                      "
                      @app-table-actions-download="actionDownload"
                      @app-table-actions-action-delete="actionDelete"
                      @app-table-actions-action-promotion-apply="
                        actionPromotionApply
                      "
                      @app-table-actions-action-promotion-delete="
                        actionPromotionDelete
                      "
                    >
                    </component>
                    <div v-else>
                      {{ item[head.key] }}
                    </div>
                  </div>
                </td>
              </template>
            </tr>
          </template>
          <tr v-if="sortedItems.length == 0" class="no-hover">
            <td :colspan="headers.length">
              <div class="text-center p-2">
                <span>{{ $t("message.thereAreNoRecordsToShow") }}</span>
              </div>
            </td>
          </tr>
        </tbody>
        <!--end::Table Body-->
      </table>
    </div>
    <!--end::Data Table-->
    <!--begin::Table Pagination-->
    <AppTablePagination
      v-if="!hidePagination"
      :pagination="pagination"
      @change="actionPaginationChange"
    ></AppTablePagination>
    <!--end::Table Pagination-->
  </div>
</template>

<script>
import AppStatusLabel from "@/views/components/bases/AppStatusLabel";
import AppTableActions from "@/views/components/bases/AppTableActions";
import AppTablePagination from "@/views/components/bases/pagination/AppTablePagination";
import HomeStatusLabel from "@/views/components/home/HomeStatusLabel";
import PermissionStatusLabel from "@/views/components/role-permission/PermissionStatusLabel";

const SORT_ORDER = {
  ASC: "asc",
  DESC: "desc",
};

export default {
  name: "AppSmartTable",
  components: {
    AppStatusLabel,
    AppTableActions,
    AppTablePagination,
    HomeStatusLabel,
    PermissionStatusLabel,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [
        {
          key: "no",
          name: "no",
          active: true,
        },
      ],
    },
    applyAllbtn: {
      type: Array,
      default: () => [
        // {
        //   key: 'no',
        //   name: 'no',
        //   active: true
        // }
      ],
    },
    pagination: {
      type: Object,
      default: () => {
        return {
          currentPage: 1,
          total: 1,
          pageSize: 10,
          lastPage: 1,
        };
      },
    },
    hidePagination: {
      type: Boolean,
      default: false,
    },
    accessRights: {
      type: Object,
      default: () => {
        return {
          moduleName: "",
          actions: {
            create: "",
            read: "",
            update: "",
            delete: "",
          },
        };
      },
    },
    subMenu: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    deliveryPromotion: [],
    sortOrder: SORT_ORDER,
    sortBy: "",
    currentSortDir: SORT_ORDER.ASC,
    promotionDelivery: {
      ids: {},
      promotionOptions: null,
      DeliveryAmounts: null,
      DeliveryValidityFrom: null,
      DeliveryValidityTo: null,
    },
    setBorderLeft: true,
    setBorderRight: false,
  }),
  beforeDestroy() {},
  computed: {
    sortedItems() {
      const dateProperties = [
        "updatedAt",
        "createdAt",
        "deletedAt",
        "verifiedAt",
        "submittedAt",
        "publishedAt",
        "approvedAt",
        "rejectedAt",
        "startDateTime",
        "endDateTime",
        "scheduledAt",
        "startDate",
        "endDate",
        "availableFrom",
        "availableTo",
        "accountDeletedAt",
        "lastLoginAt",
      ];
      var items = this.items;
      var sortBy = this.sortBy;
      var currentSortDir = this.currentSortDir;
      return items.sort((a, b) => {
        // Sort by date time
        if (dateProperties.includes(sortBy)) {
          if (a[sortBy] != "-" && b[sortBy] != "-") {
            let x = new Date(a[sortBy]).getTime();
            let y = new Date(b[sortBy]).getTime();

            if (currentSortDir === SORT_ORDER.ASC) {
              return x - y;
            } else {
              return y - x;
            }
          } else {
            return -1;
          }
        } else {
          let modifier = 1;

          if (currentSortDir === SORT_ORDER.DESC) modifier = -1;
          if (a[sortBy] < b[sortBy]) return -1 * modifier;
          if (a[sortBy] > b[sortBy]) return 1 * modifier;

          return 0;
        }
      });
    },
  },
  methods: {
    onScroll(el) {
      var $t = document.getElementById("wtable").offsetWidth;

      if (el.srcElement.scrollLeft) {
        this.setBorderLeft = true;
        this.setBorderRight = false;
        if (el.srcElement.scrollLeft < el.srcElement.clientWidth) {
          this.setBorderRight = true;
        }

        if (el.srcElement.clientWidth + el.srcElement.scrollLeft > $t - 50) {
          this.setBorderRight = false;
        }
      } else {
        this.setBorderLeft = false;
        this.setBorderRight = true;
      }
    },
    onClickSort(item) {
      if (item.sortable) {
        if (item.key === this.sortBy) {
          this.currentSortDir =
            this.currentSortDir === SORT_ORDER.ASC
              ? SORT_ORDER.DESC
              : SORT_ORDER.ASC;
        }
        this.sortBy = item.key;
      }
    },
    actionDelete(value) {
      this.$emit("app-table-action-delete", value);
    },
    actionDownload(value) {
      this.$emit("app-table-action-download", value);
    },
    actionOpenModalDetails(value) {
      this.$emit("app-table-open-modal-details", value);
    },
    actionReadDetails(value) {
      this.$emit("app-table-read-details", value);
    },
    actionPaginationChange(value) {
      this.$emit("app-smart-table-pagination-change", value);
    },
    actionPromotionApply(value) {
      var idlist = "promotionDelivery" + value;
      let selectedTxtElement = document.getElementById(idlist);
      var inputNodes = selectedTxtElement.getElementsByTagName("INPUT");
      let data = [];

      for (var i = 0; i < inputNodes.length; ++i) {
        data = data.concat(inputNodes[i].value);
      }

      if (data[0] == "Discount amount") {
        data[0] = 1;
      } else if (data[0] == "Discount percentage") {
        data[0] = 2;
      } else if (data[0] == "Max amount") {
        data[0] = 3;
      } else {
        data[0] = "";
      }

      this.promotionDelivery = {
        promotionOptions: data[0],
        DeliveryAmounts: data[1],
        DeliveryValidityFrom: data[2],
        DeliveryValidityTo: data[3],
        ids: [data[4]],
      };
      this.$emit("app-smart-table-promotion-apply", this.promotionDelivery);
    },
    actionPromotionApplyAll() {
      var idlist = "promotionDelivery";
      let selectedTxtElement = document.getElementById(idlist);
      var inputNodes = selectedTxtElement.getElementsByTagName("INPUT");
      let data = [];
      let creatorId;

      for (var i = 0; i < inputNodes.length; ++i) {
        data = data.concat(inputNodes[i].value);
      }

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      let getUrlParams = urlParams.get("creatorId");
      if (getUrlParams) {
        creatorId = getUrlParams.split(",").map(Number);
      } else {
        creatorId = [];
        for (var x = 0; x < this.filters[0].options.length; ++x) {
          creatorId = creatorId.concat(this.filters[0].options[x].value);
        }
      }

      if (data[0] == "Discount amount") {
        data[0] = 1;
      } else if (data[0] == "Discount percentage") {
        data[0] = 2;
      } else if (data[0] == "Max amount") {
        data[0] = 3;
      } else {
        data[0] = "";
      }

      this.promotionDelivery = {
        promotionOptions: data[0],
        DeliveryAmounts: data[1],
        DeliveryValidityFrom: data[2],
        DeliveryValidityTo: data[3],
        ids: creatorId,
      };
      this.$emit("app-smart-table-promotion-apply-all", this.promotionDelivery);
    },
    actionPromotionDelete(value) {
      this.$emit("app-smart-table-promotion-delete", value);
    },
    actionPromotionDeleteAll() {
      let creatorId;

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      let getUrlParams = urlParams.get("creatorId");
      if (getUrlParams) {
        creatorId = getUrlParams.split(",").map(Number);
      } else {
        creatorId = [];
        for (var x = 0; x < this.filters[0].options.length; ++x) {
          creatorId = creatorId.concat(this.filters[0].options[x].value);
        }
      }

      this.$emit("app-smart-table-promotion-delete-all", creatorId);
    },
  },
};
</script>

<style lang="scss">
.app-smart-table {
  .app-smart-table__table_container {
    overflow: auto;
    max-width: 100%;
    margin-bottom: 1rem;
    table {
      width: 100%;
      > thead {
        > tr {
          > th {
            color: #b5b5c3;
            font-size: 0.75rem;
            text-transform: uppercase;
            font-weight: 600;
            letter-spacing: 0.1rem;
            padding: 0.5rem 1.2rem;
            border-bottom: 1px solid #ebedf3;
            &.sortable {
              cursor: pointer;
            }

            .sort-icon-wrapper {
              padding-left: 8px;
            }

            span {
              &.active-sort {
                color: var(--primary) !important;
              }
            }
          }
        }
      }
      > tbody {
        > tr {
          &:hover {
            color: #3f4254;
            background-color: #e4e6ef;
          }
          &.no-hover:hover {
            color: unset !important;
            background-color: unset !important;
          }
          > td {
            padding: 0.4rem 1.2rem;
            vertical-align: middle;
            font-size: 0.8rem;
            border-bottom: 1px solid #ebedf3;
          }
          &:last-child {
            td {
              border-bottom: unset !important;
            }
          }
        }
      }
    }
  }
}
</style>
